<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 24 24"
  >
    <g id="icon_list_paidholiday" transform="translate(1694 2998)">
      <path
        id="패스_4049"
        data-name="패스 4049"
        fill="none"
        d="M0,0H24V24H0Z"
        transform="translate(-1694 -2998)"
      />
      <path
        id="flight_takeoff_FILL0_wght400_GRAD0_opsz48"
        fill="#ffc304"
        d="M5.108,25.65V24.063H24.145V25.65Z"
        transform="translate(-1696.6 -3002.475)"
      />
      <path
        id="flight_takeoff_FILL0_wght400_GRAD0_opsz48-2"
        data-name="flight_takeoff_FILL0_wght400_GRAD0_opsz48"
        fill="#087ef7"
        d="M6.773,20.15,4.05,15.523l1.137-.212,1.851,1.639,5.976-1.613L8.492,7.749,10.026,7.3l7.536,6.8,5.711-1.534a1.353,1.353,0,0,1,1.3.251,1.492,1.492,0,0,1,.582,1.229,1.483,1.483,0,0,1-1.084,1.428Z"
        transform="translate(-1696.6 -3002.475)"
      />
    </g>
  </svg>
</template>
<script>
export default {
  props: {
    width: {
      type: Number,
      default: 24,
    },
    height: {
      type: Number,
      default: 24,
    },
  },
};
</script>
